export const ADDRESSES_PAGE_SIZE = 20;
export const PAGINATION_THRESHOLD = 20;
export const PAGINATION_JUMP_CONTROLS_THRESHOLD = 11;

export const ADDRESS_FORM_DATA_TEST_IDS = {
  FIRST_NAME: 'first-name',
  LAST_NAME: 'last-name',
  ADDRESS_LINE_1: 'address-line-1',
  ADDRESS_LINE_2: 'address-line-2',
  PRIMARY_PHONE: 'primary-phone',
  CANCEL: 'cancel',
  SAVE_AND_CONTINUE: 'save-and-continue',
  zipCodeTextField: 'zipCodeTextField',
  zipCodeInput: 'zipCodeInput',
  cityStateSelect: 'cityStateSelect',
};
